export const environment = {
    prod: false,
    updateFlagsEndpoint: 'update-feature-flex',
    firebaseConfig: {
        apiKey: 'AIzaSyAHx8L_iZZMthkBv1vwBgYInC2pCF9TtwE',
        authDomain: 'feature-flex.firebaseapp.com',
        projectId: 'feature-flex',
        storageBucket: 'feature-flex.appspot.com',
        messagingSenderId: '590447126816',
        appId: '1:590447126816:web:17c842aa15736fd0878f45'
    },
    environmentId: 'b8fbd07e-6404-4e0b-83a2-5a56929bb5f3'
};
